"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreNumberBadge = _interopRequireDefault(require("@legacy-vfuk/core-number-badge"));

var Styled = _interopRequireWildcard(require("./styles/IconCelebrate.style"));

var _ruleSet = require("../../ruleSet");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconCelebrate = function IconCelebrate(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? _ruleSet.nonThemeableRules.defaultSize : _ref$size,
      _ref$isResponsive = _ref.isResponsive,
      isResponsive = _ref$isResponsive === void 0 ? false : _ref$isResponsive,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
      _ref$inverse = _ref.inverse,
      inverse = _ref$inverse === void 0 ? false : _ref$inverse,
      state = _ref.state,
      numberBadge = _ref.numberBadge;
  return /*#__PURE__*/_react["default"].createElement(Styled.IconWrapper, {
    size: size,
    isResponsive: isResponsive,
    appearance: appearance,
    inverse: inverse,
    state: state
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m12 3 .836 1.7 1.875.269-1.356 1.324.32 1.863L12 7.273l-1.676.883.32-1.863L9.29 4.969l1.875-.27ZM4.246 6.008l1.063.906 1.347-.367-.531 1.293.766 1.172-1.395-.11-.875 1.09-.328-1.36-1.309-.495 1.192-.735Zm15.508 0-1.063.906-1.347-.367.531 1.293-.766 1.172 1.395-.11.875 1.09.328-1.36 1.309-.495-1.192-.735Zm.078 9.023c0-.094.074-.168.168-.172.094 0 .172.079.172.172a.173.173 0 0 1-.168.172.173.173 0 0 1-.172-.172Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.96 15.031c0-.02.02-.039.04-.039.023 0 .043.02.043.04 0 .023-.02.042-.043.042-.02 0-.04-.02-.04-.043Zm-15.46 1c0 .278-.223.5-.5.5a.498.498 0 0 1-.5-.5.499.499 0 1 1 1 0Zm15 3c0 .278-.223.5-.5.5a.498.498 0 0 1-.5-.5.499.499 0 1 1 1 0Zm-3.164 2.524a.17.17 0 1 1 .34-.004.17.17 0 0 1-.34.004Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.465 21.555c0-.024.02-.04.043-.04a.04.04 0 0 1 .039.04c0 .02-.02.039-.04.039-.023 0-.042-.02-.042-.04ZM12 9.992V19.5m-5.57-8.469 3.129 7.008m8.007-7.008-3.132 7.008m-7.789 1.508c0 .09-.07.164-.16.164a.165.165 0 0 1-.165-.164c0-.086.075-.16.164-.16.09 0 .16.074.16.16Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.527 19.547c0 .027-.02.047-.043.047a.045.045 0 0 1-.046-.047c0-.024.019-.043.046-.043.024 0 .043.02.043.043ZM3.66 21.523c0 .09-.074.165-.164.165a.165.165 0 0 1-.164-.165c0-.09.074-.164.164-.164.09 0 .164.075.164.164Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.543 21.523a.05.05 0 0 1-.047.047c-.023 0-.043-.023-.043-.047 0-.023.02-.043.043-.043.024 0 .047.02.047.043Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }))), numberBadge && /*#__PURE__*/_react["default"].createElement(Styled.NumberBadgeContainer, null, /*#__PURE__*/_react["default"].createElement(_coreNumberBadge["default"], {
    number: numberBadge,
    appearance: inverse ? appearance : 'primary'
  })));
};

IconCelebrate.displayName = "IconCelebrate";
var _default = IconCelebrate;
exports["default"] = _default;
//# sourceMappingURL=IconCelebrate.js.map